var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19201 7.176L9.81901 36.946C9.92801 38.183 10.789 39.226 11.983 39.567L22.626 42.608C23.524 42.865 24.475 42.865 25.373 42.608L36.016 39.567C37.21 39.226 38.071 38.184 38.18 36.946L40.807 7.176C40.911 6.006 39.99 5 38.816 5H9.18401C8.01001 5 7.08901 6.006 7.19201 7.176Z",
    fill: "url(#paint0_linear_398_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8V39.9L33.876 37.078C34.673 36.85 35.247 36.154 35.319 35.329L37.605 9.087C37.656 8.502 37.196 8 36.609 8H24Z",
    fill: "#35C1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 13H24V17H28.9L28.6 21H24V25H28.4L28.1 29.5L24 30.9V35.1L31.9 32.5L32.6 21L33.1 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13V17H15.1L14.8 13H24ZM19.4 21L19.6 25H24V21H19.4ZM19.8 27H15.8L16.1 32.5L24 35.1V30.9L19.9 29.5L19.8 27Z",
    fill: "#D6E0E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M33.1 13L32.6 21L31.9 32.5L24 35.1L16.1 32.5L15.8 27H19.8L19.9 29.5L24 30.9L28.1 29.5L28.4 25H24H19.6L19.4 21H24H28.6L28.9 17H24H15.1L14.8 13H24H33.1ZM34.164 12H33.1H24H14.8H13.722L13.803 13.075L14.103 17.075L14.172 18H15.1H24H27.822L27.672 20H24H19.4H18.349L18.401 21.05L18.601 25.05L18.649 26H15.8H14.744L14.802 27.054L15.102 32.554L15.139 33.236L15.788 33.45L23.688 36.05L24 36.153L24.313 36.05L32.213 33.45L32.857 33.238L32.898 32.561L33.598 21.061L34.098 13.063L34.164 12ZM20.761 26H24H27.331L27.146 28.769L24 29.843L20.872 28.775L20.799 26.96L20.761 26Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M33.1 13L32.6 21L31.9 32.5L24 35.1L16.1 32.5L15.8 27H19.8L19.9 29.5L24 30.9L28.1 29.5L28.4 25H24H19.6L19.4 21H24H28.6L28.9 17H24H15.1L14.8 13H24H33.1ZM33.632 12.5H33.1H24H14.8H14.261L14.301 13.037L14.601 17.037L14.636 17.5H15.1H24H28.361L28.136 20.5H24H19.4H18.874L18.9 21.025L19.1 25.025L19.124 25.5H19.6H24H27.866L27.624 29.134L24 30.372L20.386 29.138L20.3 26.98L20.28 26.5H19.8H15.8H15.272L15.301 27.027L15.601 32.527L15.62 32.868L15.944 32.975L23.844 35.575L24 35.626L24.156 35.575L32.056 32.975L32.378 32.869L32.399 32.53L33.099 21.03L33.599 13.031L33.632 12.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_8",
    x1: 16.33,
    y1: -2.748,
    x2: 32.293,
    y2: 41.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.f14b087c30d9f8be331a7191cda9463f.svg";
export { ForwardRef as ReactComponent };